// extracted by mini-css-extract-plugin
export default {"info":"CourseCardLive_info__idjMB","info__text":"CourseCardLive_info__text__fMFGd","info__link":"CourseCardLive_info__link__LFB7S","support":"CourseCardLive_support__0IBQJ"};